/* eslint-disable */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import theme from "../../../../Themes/defaultTheme";

const useStyles = makeStyles({
  root: {
    height: 6,
  },
  bar: {
    backgroundColor: "#6EBB78",
  },
});

const A_LinearIndeternment = () => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <LinearProgress
        classes={{
          root: classes.root,
          bar: classes.bar,
        }}
      />
    </ThemeProvider>
  );
};

export default A_LinearIndeternment;
